import { useState, useEffect } from 'react'
import api from '@api'
import ImportSummary from '../ImportSummary'
import { ApolloError } from 'apollo-boost'

interface ImportSummary {
  totalCount: number
  createdCount: number
  failedCount: number
}

interface ImportSummaryHook {
  loading: boolean
  summary: ImportSummary
  error: ApolloError | null
}

export default function useImportSummary(id: string) {
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<ApolloError | null>(null)
  const [summary, setSummary] = useState<ImportSummary>({
    totalCount: 0,
    createdCount: 0,
    failedCount: 0,
  })

  useEffect(() => {
    api.booking.import
      .summary(id)
      .then((summary) => {
        setLoading(false)
        setSummary(summary)
      })
      .catch((error) => {
        setError(error)
        setLoading(false)
      })
  }, [id])

  return { loading, error, summary }
}
